<template>
    <!-- Collect investor details -->
    <a-card :bordered="false">  
        <a-row :gutter="[24, 16]">
            <a-col :span="5">
                <div class="form-item">
                    <span class="form-label">{{ $t('platformCollection.fee_details_collection_time') }}:</span>
                    <a-range-picker :label="$t('platformCollection.fee_details_collection_time')"
                        v-model:value="dateRange"
                        :format="dateFormat" style="width: 100%" />
                </div>
            </a-col>

            <a-col :span="5">
                <div class="form-item">
                    <a-input-group compact>
                        <a-select default-value="jack" style="width: 100px" @change="(value) => handleChange(value, 'searchType')">
                            <a-select-option value="jack">{{ $t('platformCollection.fee_details_account') }}</a-select-option>
                            <a-select-option value="name">{{ $t('platformCollection.fee_details_name') }}</a-select-option>
                        </a-select>
                        <a-input v-model:value="searchValue" :placeholder="searchType === 'mobile' ? $t('platformCollection.fee_details_please_enter_account') : $t('platformCollection.fee_details_please_enter_name')" style="width: calc(100% - 100px)"></a-input>
                    </a-input-group>
                </div>
            </a-col>

            <a-col :span="5">
                <div class="form-item">
                    <span class="form-label">{{ $t('platformCollection.fee_details_fee_name') }}:</span>
                    <a-input v-model:value="feeName" :placeholder="$t('platformCollection.fee_details_please_enter_fee_name')" style="width: 100%"></a-input>
                </div>
            </a-col>

            <a-col :span="5">
                <div class="form-item">
                    <span class="form-label">{{ $t('platformCollection.fee_details_collection_node') }}:</span>
                    <dict-select
                        v-model="collectionNode"
                        :dict-code="DICT_CODE.FEE_AMOUNT_DETAIL_JUNCTURE"
                        :begin="[{ value: '', label: $t('platformCollection.fee_details_all'), labelEn: 'All', labelEs: 'Tất cả' }]"
                    />
                </div>
            </a-col>

            <a-col :span="4">
                <div class="form-item">
                    <span class="form-label">{{ $t('platformCollection.fee_details_investor_type') }}:</span>
                    <a-select :value="investorType" style="width: 100%" @change="(value) => handleChange(value, 'investorType')">
                        <a-select-option :value="-1">{{ $t('platformCollection.fee_details_all') }}</a-select-option>
                        <a-select-option :value="1">{{ $t('platformCollection.fee_details_individual') }}</a-select-option>
                        <a-select-option :value="10">{{ $t('platformCollection.fee_details_enterprise') }}</a-select-option>
                    </a-select>
                </div>
            </a-col>

            <a-col :span="3">
                <a-button type="primary" @click="search">{{ $t('platformCollection.fee_details_query') }}</a-button>
            </a-col>
        </a-row>
        <a-table :columns="i18nColumns" :data-source="data" :pagination="paginationState" :loading="loading" bordered style="margin-top: 26px;">
            <span slot="receivableAmount" slot-scope="text">
                {{ text | FenToDong }}
            </span>
            <span slot="actualAmount" slot-scope="text">
                {{ text | FenToDong }}
            </span>
            <span slot="collectionNode" slot-scope="text">
                <Dict :dict-code="DICT_CODE.FEE_AMOUNT_DETAIL_JUNCTURE" :value="text" />
            </span>
            <span slot="collectionStandard" slot-scope="text, record" style="white-space: nowrap;">
                <Dict :dict-code="DICT_CODE.AMOUNT_TYPE" :value="record.amountType" />
                {{ record.fixedFee ? record.fixedFee : record.percentFee ? record.percentFee * 100 + '%' : '' }}
            </span>
        </a-table>
    </a-card>
</template>

<script>
import moment from 'moment'
import { getChargeDetail } from '@/webpublicapi/vietnamBackstage'
import DictSelect from '@/views/webpublic/modules/DictSelect'
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'

const columns = [
    {
        title: 'investor_name',
        dataIndex: 'borrowerName',
        align: 'center',
    },
    {
        title: 'fee_details_account',
        dataIndex: 'account',
        align: 'center',
    },
    {
        title: 'fee_details_investor_type',
        dataIndex: 'investorType',
        align: 'center',
    },
    {
        title: 'fee_details_fee_name_title',
        dataIndex: 'feeName',
        align: 'center',
    },
    {
        title: 'fee_details_collection_node_title',
        dataIndex: 'collectionNode',
        align: 'center',
        scopedSlots: { customRender: 'collectionNode' },
    },
    {
        title: 'fee_details_collection_standard',
        dataIndex: 'collectionStandard',
        align: 'center',
        scopedSlots: { customRender: 'collectionStandard' },
    },
    {
        title: 'fee_details_receivable_amount',
        dataIndex: 'receivableAmount',
        align: 'center',
        scopedSlots: { customRender: 'receivableAmount' },
    },
    {
        title: 'fee_details_actual_amount',
        dataIndex: 'actualAmount',
        align: 'center',
        scopedSlots: { customRender: 'actualAmount' },
    },
    {
        title: 'fee_details_collection_time_title',
        dataIndex: 'collectionTime',
        align: 'center',
    },
    {
        title: 'fee_details_effective_date',
        dataIndex: 'effectiveDate',
        align: 'center',
    },
]

export default {
    name: 'CollectFromInvestors',
    components: { DictSelect, Dict },
    data() {
        return {
            DICT_CODE,
            dateFormat: 'DD/MM/YYYY',
            monthFormat: 'YYYY/MM',
            dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
            data: [],
            columns,
            paginationState: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (current, pageSize) => {
                    this.paginationState.current = current
                    this.paginationState.pageSize = pageSize
                    this.search()
                }
            },
            dateRange: [],
            searchType: 'mobile',
            searchValue: '',
            feeName: '',
            collectionNode: '',
            investorType: -1,
            loading: false
        }
    },
    computed: {
        i18nColumns() {
            return this.columns.map(col => ({
                ...col,
                title: this.$t('platformCollection.' + col.title)
            }))
        }
    },
    mounted() {
        this.search()
    },
    methods: {
        moment,
        handleChange(value, type) {
            if (type === 'investorType') {
                this.investorType = parseInt(value)
            } else if (type === 'collectionNode') {
                this.collectionNode = value === 'jack' ? '' : value
            } else {
                this.searchType = value === 'jack' ? 'mobile' : 'realName'
            }
        },
        search() {
            this.loading = true
            const params = {
                pageNo: this.paginationState.current,
                pageSize: this.paginationState.pageSize,
            }
            if (this.investorType !== -1) {
                params.userType = this.investorType
            }
            
            if (this.dateRange && this.dateRange.length === 2) {
                params.begin = this.dateRange[0].format('YYYY/MM/DD')
                params.end = this.dateRange[1].format('YYYY/MM/DD')
            }
            
            if (this.searchValue) {
                if (this.searchType === 'mobile') {
                    params.mobile = this.searchValue
                } else {
                    params.realName = this.searchValue
                }
            }
            
            if (this.feeName) {
                params.title = this.feeName
            }
            
            if (this.collectionNode) {
                params.juncture = this.collectionNode
            }
            
            getChargeDetail(params).then(res => {
                console.log(res)
                if (res && res.respData) {
                    this.data = res.respData.records.map(item => ({
                        key: item.id,
                        borrowerName: item.realName,
                        account: item.mobile,
                        investorType: parseInt(item.userType) === -1 ? this.$t('platformCollection.fee_details_all') : parseInt(item.userType) === 1 ? this.$t('platformCollection.fee_details_individual') : parseInt(item.userType) === 10 ? this.$t('platformCollection.fee_details_enterprise') : '',
                        feeName: item.title,
                        collectionNode: item.juncture,
                        amountType: item.amountType,
                        fixedFee: item.fixedFee,
                        percentFee: item.percentFee,
                        collectionStandard: '',
                        receivableAmount: item.receivable,
                        actualAmount: item.received,
                        collectionTime: this.transformTime(item.createDate,1),
                        effectiveDate: this.transformTime(item.createDate,1) // No effective date in API response, temporarily use collection time
                    }))
                    this.paginationState.total = res.respData.total || 0
                    console.log( this.data)
                }
                this.loading = false
            }).catch(err => {
                console.error( err)
                this.loading = false
            })
        }
    },

}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.form-item {
    display: flex;
    align-items: center;
    gap: 8px;

    .form-label {
        min-width: 80px;
        text-align: right;
        white-space: nowrap;
        flex-shrink: 0;
    }

    :deep(.dict-select-wrapper) {
        flex: 1;
    }

    :deep(.ant-input),
    :deep(.ant-select),
    :deep(.ant-picker) {
        flex: 1;
    }
}
</style>